import React, { useEffect, useState } from "react";
import { useAppState } from "../../context/appContex";
import { ReactComponent as SearchIcon } from "../icons/search.svg";
// import { EventContext } from "direflow-component";

interface GlobalSearchProps {
  handleSearch: (searchValue: string) => void;
  closeGlobalSearch: () => void;
}
const GlobalSearch: React.FC<GlobalSearchProps> = ({
  handleSearch,
  closeGlobalSearch,
}) => {
  const [searchValue, setSearchValue] = useState("");
  const { menuData, isGlobalSearchVisible } = useAppState();

  // const dispatch = useContext(EventContext);

  // const escFunction = useCallback(
  //   (event: KeyboardEvent) => {
  //     if (event.key === "Escape") {
  //       closeGlobalSearch();
  //       setSearchValue("");
  //     }
  //   },
  //   [closeGlobalSearch]
  // );

  useEffect(() => {
    if (!isGlobalSearchVisible) {
      setSearchValue("");
    }
  }, [isGlobalSearchVisible]);

  // useEffect(() => {
  //   document.addEventListener("keydown", escFunction, false);

  //   return () => {
  //     document.removeEventListener("keydown", escFunction, false);
  //   };
  // }, [escFunction]);

  // &section=search&q=

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    e.stopPropagation();
    if (menuData) {
      window.location.href = `${menuData.system.homeMenuItem.targetUrl}&section=search&q=${searchValue}`;
    }
  };

  return (
    <div className='search-container'>
      <SearchIcon />
      <form onSubmit={onSubmit} style={{ width: "100%" }}>
        <input
          type='text'
          placeholder='Search'
          autoFocus
          value={searchValue}
          onChange={(e) => {
            handleSearch(e.target.value);
            setSearchValue(e.target.value);
          }}
        />
      </form>
      <button
        className='esc'
        onClick={() => {
          const event = new CustomEvent("close-global-search");
          dispatchEvent(event);
          setSearchValue("");
          closeGlobalSearch();
        }}
      >
        esc
      </button>
    </div>
  );
};

export default GlobalSearch;
